import { render, staticRenderFns } from "./day.vue?vue&type=template&id=0ed23978"
import script from "./day.vue?vue&type=script&lang=js"
export * from "./day.vue?vue&type=script&lang=js"
import style0 from "./day.vue?vue&type=style&index=0&id=0ed23978&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports